export default __webpack_public_path__ + "static/media/home-page-reports.5ea8423f.jpg";